module.exports = __webpack_public_path__ + "static/media/mbl.c2be9d02.png";